import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// <!doctype html>
// <html lang="en">
//     <head>
//         <meta charset="utf-8"/>
//         <link rel="icon" href="/favicon.ico"/>
//         <meta name="viewport" content="width=device-width,initial-scale=1"/>
//         <meta name="theme-color" content="#000000"/>
//         <meta name="keywords" content="A2 cow milk in noida ,Best dairy products in greater noida ,Fresh milk delivery in near me"/>
//         <meta name="description" content="Experience the purity of A2 cow milk and organic dairy products with Gaubliiss. Fresh, unadulterated, and nutrient-rich milk delivered to your doorstep. Taste the bliss of nature with Gaubliiss!"/>
//         <title> Gaubliiss - Pure A2 Cow Milk & Organic Dairy Products in Noida</title>
//     </head>
//         <body>
//         <div id="root">
//         </div>
//         </body>
//         </html>
